import React, { useState } from "react";
import "./Add_Bank_Account.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import {
  FaUser,
  FaCreditCard,
  FaPhone,
  FaKey,
  FaInfoCircle,
} from "react-icons/fa";
import { faBuildingColumns } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Add_Bank_Account() {
  const [selectedBank, setSelectedBank] = useState(null);

  const bankOptions = [
    { value: "sbi", label: "State Bank Of India" },
    { value: "hdfc", label: "HDFC Bank" },
    { value: "icici", label: "ICICI Bank" },
  ];

  return (
    <section className="Add_Bank_Account">
      <Common_white_header headingText={"Add a Bank Account"} />

      <div className="container">
        <div className="Add_Bank_Account_holder">
          {/* Info Message */}
          <div className="info-box">
            <FaInfoCircle className="info-icon" />
            <span>
              To ensure the safety of your funds, please bind your bank account
            </span>
          </div>

          <Form className="bank-form field_holder">
            {/* Choose Bank */}
            <Form.Group className="form-group">
              <Form.Label>
                <FontAwesomeIcon
                  icon={faBuildingColumns}
                  className="input-icon"
                />{" "}
                Choose a bank
              </Form.Label>
              <Select
                options={bankOptions}
                value={selectedBank}
                onChange={setSelectedBank}
                placeholder="Please select a bank"
                classNamePrefix="custom-select"
              />
            </Form.Group>

            {/* Full Name */}
            <Form.Group className="form-group">
              <Form.Label>
                {" "}
                <FaUser className="input-icon" /> Full recipient's name
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control type="text" placeholder="Enter name" />
              </div>
            </Form.Group>

            {/* Account Number */}
            <Form.Group className="form-group">
              <Form.Label>
                {" "}
                <FaCreditCard className="input-icon" />
                Bank account number
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control type="text" placeholder="Bank account number" />
              </div>
            </Form.Group>

            {/* Confirm Account Number */}
            <Form.Group className="form-group">
              <Form.Label>
                <FaCreditCard className="input-icon" /> Confirm Bank account
                number
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Confirm Bank account number"
                />
              </div>
            </Form.Group>

            {/* Phone */}
            <Form.Group className="form-group">
              <Form.Label>
                {" "}
                <FaPhone className="input-icon" /> Phone number
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control type="text" placeholder="Enter Phone number" />
              </div>
            </Form.Group>

            {/* IFSC */}
            <Form.Group className="form-group">
              <Form.Label>
                {" "}
                <FaKey className="input-icon" /> IFSC Code
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Please enter IFSC code"
                />
              </div>
            </Form.Group>

            {/* Save Button */}
            <Button className="gray_btn" >
              Save
            </Button>
          </Form>
        </div>
      </div>
    </section>
  );
}

export default Add_Bank_Account;
